import { useState, useEffect } from 'react';
import { useI18n } from '../../../../../i18n';
import { LoadingSpinner } from '../../../../shared/components/LoadingSpinner';
import { ConfirmDialog } from '../../../../shared/components/ConfirmDialog';
import {
  fetchPersonaProyectos,
  desasignarPersonaProyecto,
  type ProyectoAsignacionItem,
} from '../../../../shared/services/api';
import { cardStyle, formatDate } from './persona-detail-shared';

export function PersonaProyectosTab({ personaId }: { personaId: string }) {
  const { t } = useI18n();
  const [proyectos, setProyectos] = useState<ProyectoAsignacionItem[]>([]);
  const [loading, setLoading] = useState(true);
  const [confirmState, setConfirmState] = useState<{
    open: boolean;
    title: string;
    message: string;
    danger?: boolean;
    onConfirm: () => void;
  } | null>(null);

  useEffect(() => {
    fetchPersonaProyectos(personaId)
      .then((r) => setProyectos(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [personaId]);

  const handleRemove = (asignacionId: string) => {
    setConfirmState({
      open: true,
      title: t.common.confirmar,
      message: t.people.confirmDesasignarProyecto,
      danger: true,
      onConfirm: async () => {
        await desasignarPersonaProyecto(personaId, asignacionId);
        fetchPersonaProyectos(personaId)
          .then((r) => setProyectos(r.data))
          .catch(() => {});
      },
    });
  };

  if (loading)
    return (
      <div style={{ padding: 20 }}>
        <LoadingSpinner size="sm" muted />
      </div>
    );

  return (
    <div style={cardStyle}>
      <h3 style={{ margin: '0 0 12px', fontSize: 14, color: 'var(--color-primario)' }}>
        Proyectos Asignados
      </h3>
      {proyectos.length === 0 ? (
        <div style={{ color: '#9CA3AF', fontSize: 13 }}>Sin proyectos asignados</div>
      ) : (
        <table style={{ width: '100%', borderCollapse: 'collapse' }}>
          <thead>
            <tr style={{ backgroundColor: '#0E243E' }}>
              <th
                style={{
                  textAlign: 'left',
                  padding: '14px 20px',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 12,
                  textTransform: 'uppercase',
                  letterSpacing: '0.8px',
                }}
              >
                Proyecto
              </th>
              <th
                style={{
                  textAlign: 'left',
                  padding: '14px 20px',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 12,
                  textTransform: 'uppercase',
                  letterSpacing: '0.8px',
                }}
              >
                Rol
              </th>
              <th
                style={{
                  textAlign: 'center',
                  padding: '14px 20px',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 12,
                  textTransform: 'uppercase',
                  letterSpacing: '0.8px',
                }}
              >
                Dedicacion
              </th>
              <th
                style={{
                  textAlign: 'center',
                  padding: '14px 20px',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 12,
                  textTransform: 'uppercase',
                  letterSpacing: '0.8px',
                }}
              >
                Estado
              </th>
              <th
                style={{
                  textAlign: 'center',
                  padding: '14px 20px',
                  color: '#fff',
                  fontWeight: 700,
                  fontSize: 12,
                  textTransform: 'uppercase',
                  letterSpacing: '0.8px',
                }}
              >
                Desde
              </th>
              <th style={{ padding: '14px 20px' }}></th>
            </tr>
          </thead>
          <tbody>
            {proyectos.map((pp) => (
              <tr key={pp.id} style={{ borderBottom: '1px solid #F2F4F6' }}>
                <td style={{ padding: '14px 20px', fontWeight: 500, fontSize: 14 }}>
                  <div>{pp.proyecto?.nombre}</div>
                  <div style={{ fontSize: 11, color: '#9CA3AF' }}>{pp.proyecto?.codigo}</div>
                </td>
                <td style={{ padding: '14px 20px', fontSize: 14 }}>{pp.rol ?? '—'}</td>
                <td style={{ padding: '14px 20px', textAlign: 'center', fontSize: 14 }}>
                  {pp.dedicacion != null ? `${pp.dedicacion}%` : '—'}
                </td>
                <td style={{ padding: '14px 20px', textAlign: 'center' }}>
                  <span
                    style={{
                      padding: '4px 12px',
                      borderRadius: 4,
                      fontSize: 13,
                      fontWeight: 500,
                      background: '#EFF6FF',
                      color: '#1D4ED8',
                    }}
                  >
                    {pp.proyecto?.estado}
                  </span>
                </td>
                <td style={{ padding: '14px 20px', textAlign: 'center', fontSize: 14 }}>
                  {formatDate(pp.fechaInicio)}
                </td>
                <td style={{ padding: '14px 20px', textAlign: 'center' }}>
                  <button
                    onClick={() => handleRemove(pp.id)}
                    style={{
                      padding: '4px 12px',
                      border: '1px solid #DC2626',
                      borderRadius: 4,
                      background: 'transparent',
                      color: '#DC2626',
                      cursor: 'pointer',
                      fontSize: 13,
                      fontFamily: 'inherit',
                    }}
                  >
                    Desasignar
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}

      {confirmState && (
        <ConfirmDialog
          open={confirmState.open}
          title={confirmState.title}
          message={confirmState.message}
          danger={confirmState.danger}
          onConfirm={confirmState.onConfirm}
          onCancel={() => setConfirmState(null)}
        />
      )}
    </div>
  );
}
